import Component from "../../classes/Component";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";

const {hasClass, toggleClass} = $dom

const accordionDetailGroupSelector = '.js-accordion-detail-group'
const accordionDetailButtonSelector = '.js-accordion-detail-button'

const activeClass = 'detail__item-accordion'

export default function () {
    const handleOpenOrCloseAccordion = (e) => {
        console.log(e.target)
        if (!hasClass(e.target, accordionDetailButtonSelector)) {
            toggleClass(e.target.closest(accordionDetailButtonSelector).nextElementSibling, activeClass)
        } else {
            toggleClass(e.target.nextElementSibling, activeClass)
        }

    }

    return new Component({
        name: 'accordion2',
        requiredTargets: [accordionDetailGroupSelector, accordionDetailButtonSelector],
        onInit() {
            $events.delegate.on('click', accordionDetailButtonSelector, handleOpenOrCloseAccordion)
        },
        onDestroy() {
            console.log('accordion2')
        },
    })

}